<template>
    <div>
        <Header />
        <div class="desktop">
            <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
        </div>
        <div class="mobile">
            <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText"
                :isTextinput="false" />
        </div>
        <BodyLinks />
        <b-container class=" mt-4">
            <Activation />
            <b-row class="desktop">
                <b-col cols="3">
                    <LanguageEventsSidebar :filterType='listingTypeSelected' class="mt-5" bookings='active' />
                </b-col>
                <b-col cols="9">
                    <b-row class="head-box mb-4">
                        <b-col cols="4" class="">
                            <b-input-group class="">
                                <b-input-group-prepend is-text>
                                    <b-icon font-scale="0.99" icon="calendar2-date"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="text" placeholder="Listing Name "></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col cols="4" class="">
                            <b-input-group class="">
                                <b-input-group-prepend is-text>
                                    <b-icon font-scale="0.99" icon="globe"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="text" placeholder="Location "></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col cols="4" class="btn-box">
                            <button class="btn btn-warning btn-culture">
                                <b-icon font-scale="0.99" icon="search"></b-icon>Search
                            </button>
                        </b-col>
                    </b-row>
                    <div class="mt-4" v-if="loading">
                        <content-loader :speed="2" :height="400" :width="600">
                            <circle cx="25" cy="112" r="15" />
                            <rect x="10" y="18" rx="0" ry="0" width="464" height="9" />
                            <rect x="497" y="10" rx="0" ry="0" width="144" height="144" />
                            <rect x="10" y="41" rx="0" ry="0" width="464" height="9" />
                            <rect x="10" y="65" rx="0" ry="0" width="364" height="9" />
                            <rect x="50" y="98" rx="0" ry="0" width="115" height="9" />
                            <rect x="50" y="115" rx="0" ry="0" width="115" height="10" />
                        </content-loader>
                    </div>
                    <p class="mt-4 d-flex justify-content-between" v-if="!loading">
                        <span>
                            Per page:
                            <select class="" v-model="no_per_page" @change="getAllBookings(page)">
                                <option value="10" selected>10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select> items
                        </span>
                        <span>{{page}} of {{rows}} Bookings</span>
                    </p>
                    <div v-if="bookings.length > 0">
                        <BookingCard v-for="list in bookings" details_route_name="language-event-details"
                            :routeId="list.event.course_id" @handleCancel="openCancelModal(list)"
                            @handleMessage="showMessage(list)" torouteName="pay" :bookingId="list.event_booking_id"
                            :key="list.value" class="mt-2 mb-4" :imgUrl="list.event.images" :listName="list.event.title"
                            :type="type" :amount="list.event.amount" :message="list.message_to_guest"
                            :currency="list.event.currency" :listDesc="list.event.course_description"
                            :needPayment="checkforPayment(list)" :dateTime="fromDateTime(list)" :status="list.status" />
                    </div>
                    <div class="mt-4" v-if="bookings.length == 0 && !loading">
                        No bookings yet
                    </div>

                </b-col>
            </b-row>
            <div class="mobile">
                <b-row>
                    <b-col cols="3">
                        <LanguageEventsSidebar @handleOpen="openMenu" @handleHide="hideSidemenu" menuId="slidmenu"
                            :filterType='listingTypeSelected' class="mt-5" bookings='active' />
                    </b-col>
                    <b-col cols="9">
                        <b-row class="head-box mb-4">
                            <b-col cols="12" class="">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon font-scale="0.99" icon="calendar2-date"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" placeholder="Listing Name "></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col cols="12" class="">
                                <b-input-group class="">
                                    <b-input-group-prepend is-text>
                                        <b-icon font-scale="0.99" icon="globe"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" placeholder="Location "></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col cols="12" class="btn-box">
                                <button class="btn btn-warning btn-culture">
                                    <b-icon font-scale="0.99" icon="search"></b-icon>Search
                                </button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <p>{{bookings.length}}</p>
                <div>
                    <BookingCard v-for="list in bookings" details_route_name="language-event-details"
                        :routeId="list.event.course_id" @handleCancel="openCancelModal(list)"
                        @handleMessage="showMessage(list)" torouteName="pay" :bookingId="list.event_booking_id"
                        :key="list.value" class="mt-2 mb-4" :imgUrl="list.event.images" :message="list.message_to_guest"
                        :type="type" :listName="list.event.title" :amount="list.event.amount"
                        :currency="list.event.currency" :listDesc="list.event.course_description"
                        :needPayment="checkforPayment(list)" :dateTime="fromDateTime(list)" :status="list.status" />
                </div>

            </div>
        </b-container>
        <b-modal id="cancel-event" centered title="Message to Host" hide-footer>
            <div class="text-center">
                <b-form-group class="col-md-12 mt-2 mb-4" label-for="message">
                    <textarea style="height:auto !important;border:1px solid #ccc !important;" required
                        v-model="message" rows="7" placeholder="Any message to the host?"
                        class="form-control"></textarea>
                </b-form-group>
                <button @click="cancelEvent" class="btn btn-warning btn-below">
                    {{sendbtnText}}
                    <b-icon font-scale="0.99" icon="arrow-right"></b-icon>
                </button>
            </div>

        </b-modal>
        <b-modal id="message" hide-header centered title="Message" hide-footer>
            <div class="text-center">
                <p class="font-weight-bold mt-3 mb-3">Message</p>
                <p class="shadow-container custome-card">{{message}}</p>
            </div>

        </b-modal>
        <Footer />
    </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import LanguageEventsSidebar from "@/components/LanguageEventsSidebar.vue"
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import BookingCard from "@/components/BookingCard.vue";
import Activation from "@/components/Activation.vue";
import {
    ContentLoader
} from "vue-content-loader";
import axios from 'axios';
import {
    getBaseUrl
} from "../../../../utils/common";
const base_url = getBaseUrl();
export default {
    name: 'manage-language-events',
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        LanguageEventsSidebar,
        BookingCard,
        ContentLoader,
        Activation,
        Footer
    },
    data: function () {
        return {
            headerText: "Booked Language Courses",
            subText: "See bookings for language courses both online and offline",
            fadedText: "Guests",
            sendbtnText: "Send",
            listingTypeSelected: null,
            loading: true,
            bookings: [],
            booking: {
                message_to_host: '',
                status: ''
            },
            booking_id: '',
            message: '',
            no_per_page: 10,
            page: 1,
            pagination: {},
            type:''
        }
    },
    computed: {
        rows() {
            return this.pagination.total
        }
        
    },
    mounted() {
        this.getAllBookings()
    },
    methods: {
        checkforPayment(list) {
            const resp = list.pending_payment === 'yes' && list.status !== 'approved' ? 'yes' : 'no';
            return resp;
        },
        showMessage(list) {
            this.$bvModal.show('message')
            this.message = list.message_to_guest
        },
        fromDateTime(event) {
            return event.event.created_at.split(" ")[0];
        },
        openCancelModal(event) {
            this.$bvModal.show("cancel-event")
            this.event = event
            this.booking_id = event.event_booking_id
            this.booking.status = "cancelled";
        },
        async getAllBookings(page = 1) {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/eventactions?action=booking&section=course`,
                    params: {
                        page: page,
                        no_per_page: this.no_per_page
                    },
                    method: "GET",
                })
                this.loading = false;
                this.bookings = resp.data.data.as_guest;
                this.type = resp.data.data.type;
            } catch (error) {
                this.loading = false;
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        openMenu() {
            this.$root.$refs.A.openMenu('slidmenu')
        },
        hideSidemenu() {
            this.$root.$refs.A.hideSidemenu('slidmenu')
        },
        async cancelEvent() {
            if (confirm("Do you really want to cancel this course event?")) {
                this.sendbtnText = 'Sending...'
                const event_booking_id = this.booking_id
                this.booking.message_to_host = this.message
                try {
                    await axios({
                        url: `${base_url}/api/v2/eventactions/${event_booking_id}?action=booking&section=course`,
                        data: this.booking,
                        method: "PUT",
                    })
                    this.sendbtnText = 'Send'
                    this.loading = false;
                    this.$root.$refs.A.makeToast('success', 'Action Successful')
                    this.$bvModal.hide('cancel-event')
                    this.getAllBookings();
                } catch (error) {
                    this.sendbtnText = 'Send'
                    this.loading = false;
                    this.$root.$refs.A.makeToast('danger', error.response.data.message)
                }
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.custom-select {
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
    border-radius: 8px;
    padding: 20px 16px;
    border: none;
    height: 59px;
    width: 95%;
}

.btn-culture {
    padding: 10px 60px !important;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        display: block;
        width: 100%;
        padding: 10px 15px !important;
        text-align: center;
    }
}

.form-control {
    border-radius: 0 8px 8px 0 !important;
    height: calc(2em + 0.75rem + 8px) !important;

}

.form-control:focus {
    outline: none !important;
    box-shadow: none !important;
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.bi-search {
    margin-right: 1rem;
}

.custom-select .caret {
    padding-right: 10px;
}

.custom-control {
    margin: 20px auto
}

.btn-box {
    margin: 14px 0
}

.head-box {
    margin: 35px auto auto;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    border-radius: 5px;
    padding: 10px;
    background-color: #F6F7F7;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        margin: 0;
    }
}

.top-box {
    margin: 10px auto 20px auto;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    border-radius: 5px;
    padding: 10px;
    background-color: #fff;
}

.inner-header-box {
    padding: 20px;
    border-radius: 4px;
    cursor: pointer;
}

.inner-header-box:hover,
.inner-header-box.active {
    background: #000;
    color: #fff;
    border-radius: 4px;
    transition: ease-in 0.3s;

}

.inner-header-box:hover .b-icon.bi,
.inner-header-box.active .b-icon.bi {
    color: rgba(247, 177, 49, 1)
}

.list-group {
    padding: 16px 16px 16px 16px;
    background: #FFFFFF;
    box-shadow: 2px 6px 19px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
}

.list-group-item {
    padding: 0.7rem 1rem !important;
    text-align: left;
    border: none !important;
    margin: 10px 0 !important;
}

.list-group-item.active {
    background: rgba(86, 92, 99, 0.05) !important;
    color: rgba(86, 92, 99, 1) !important;
    text-align: center !important
}
</style>
